import styled, { css } from "styled-components";

const ProgressBarStyled = styled.div`
position: relative;
border-top: 3px solid #D9D9D9;
flex-grow: 1;
.tickMarkFirst, .tickMarkLast {
    position: absolute;
    top: -1rem;
    width: 2rem;
    height: 2rem;
    background-repeat: no-repeat;
    background-size: contain;
    background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjJweCIgaGVpZ2h0PSIyMnB4IiB2aWV3Qm94PSIwIDAgMjIgMjIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzLjIgKDcyNjQzKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5JY29uL2lkZWwgdGljazwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iVUktLy1Qcm9ncmVzcy1iYXItLy1EZXNrdG9wLS8tMi1TdGVwcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi4wMDAwMDAsIDIuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJVSS0vLVByb2dyZXNzLWJhci0vLURlc2t0b3AtLy0zLVN0ZXBzIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJJY29uL2lkZWwtdGljayI+CiAgICAgICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIiBmaWxsPSIjRUVFREVDIiBjeD0iOSIgY3k9IjkiIHI9IjEwIj48L2NpcmNsZT4KICAgICAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Ikljb24vdGljay13aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNS4wMDAwMDAsIDYuMDAwMDAwKSIgc3Ryb2tlPSIjRDBEMENFIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMC4wNzk0MTkwMTE4LDMuMTkyNjYyMjIgTDIuMjAzOTI3MDcsNS42NDY0NjkwMiIgaWQ9IlN0cm9rZS0yMyI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTcuMjc3MzE1ODUsMi44NDIxNzA5NGUtMTQgTDIuODQ1ODQ5OCw1LjA4ODg0MTc2IiBpZD0iU3Ryb2tlLTI1Ij48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==);
    
}

.firstTitle, .nextTitle {
    position absolute;
    top: 2.5rem;
}

.nextTitle {
  color: ${props => props.theme.midGray};
}

.firstTitle, .tickMarkFirst {
    left: 0;
}

.nextTitle, .tickMarkLast {
    right: 0;
}

${props => {
    return (
      props.active &&
      css`
      border-top: 3px solid ${props => props.theme.lightGreen};
      .tickMarkFirst {
        background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTQgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzLjIgKDcyNjQzKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5JY29uL2dyZWVuIHRpY2svbW9iaWxlPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlN5bWJvbHMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJJY29uL2dyZWVuLXRpY2svbW9iaWxlIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBmaWxsPSIjMDBBNzZBIiBjeD0iNyIgY3k9IjciIHI9IjciPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikljb24vdGljay13aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC4yNjA4NzAsIDQuODY5NTY1KSIgc3Ryb2tlPSIjRkZGRkZGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMS42Ij4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMC4wNjM1MzUyMDk0LDIuNTU0MTI5NzcgTDEuNzYzMTQxNjUsNC41MTcxNzUyMiIgaWQ9IlN0cm9rZS0yMyI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik01LjgyMTg1MjY4LDIuODQyMTcwOTRlLTE0IEwyLjI3NjY3OTg0LDQuMDcxMDczNDEiIGlkPSJTdHJva2UtMjUiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+);
        background-repeat: no-repeat;
        background-size: contain;
      }
    `
    );
  }}

${props => {
    return (
      props.centerText &&
      css`
      .nextTitle {
        right: -25%;
      }
    `
    );
  }}

`;

export default ProgressBarStyled;
